import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import util from '../../../../../share/util/utils';
import { REQUEST_STATUS_COMPLETED } from '../../../../../../../share/src/util/api/polling';
import { executeSyncRequest } from '../../../../../share/util/api/syncRequest';
import apiService from '../../../../../share/util/api/service';

/**
 * 履歴データ読み出し処理（各DIDレコード処理）
 * @param {object} self this インスタンス
 * @param {string} selectedDid 選択されたDID
 * @returns 実行結果
 */
export async function readHistoryDetail(self, selectedDid) {
  try {
    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        is_special: true,
        type: 'read_history_detail',
        did: selectedDid
      },
      // エラー発生のコールバックを実装
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    if (!response) {
      // pollingWspApiはエラーコールバックの終了を待たずnullを返す
      // 非同期処理を含んでいるshowUnexpectedErrorが呼ばれた場合、スピナー消えてしまうためPromiseの解決を待つ
      if (self.exitPromise) await self.exitPromise;
      return false;
    }

    // 正常コールバック
    if (response.data?.status === REQUEST_STATUS_COMPLETED) {
      // 進捗率による再帰処理の判定
      if (await targetProgressJudge(self, response.data.user_data)) {
        return true;
      }
    }
    return false;
  } finally {
    // noop(プログレスバー表示のため、スピナー非表示)
  }
}

/**
 * 履歴データ読み出し処理（各DIDレコード処理）(GETのみ)
 * @param {object} self this インスタンス
 * @param {string} readDetailRequestId POST_API実行時のリクエストID
 * @returns 実行結果
 */
async function getReadHistoryDetailResult(self, readDetailRequestId) {
  try {
    const response = await executeSyncRequest(
      self,
      async () => {
        return await apiService.getCall(
          apiService.WSP,
          `/netApps/${self.netAppId}/systems/${self.systemId}/workSupports/${self.workSupportId}/requests/${readDetailRequestId}`,
          self.operationScreen
        );
      },
      // エラー発生のコールバックを実装
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // GET API で正常レスポンスが返ってきた際の内容チェックはデフォルト処理を利用
      undefined,
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    if (!response) {
      // pollingWspApiはエラーコールバックの終了を待たずnullを返す
      // 非同期処理を含んでいるshowUnexpectedErrorが呼ばれた場合、スピナー消えてしまうためPromiseの解決を待つ
      if (self.exitPromise) await self.exitPromise;
      return false;
    }

    // 正常コールバック
    if (response.data?.status === REQUEST_STATUS_COMPLETED) {
      // 進捗率による再帰処理の判定
      if (await targetProgressJudge(self, response.data.user_data)) {
        return true;
      }
    }
    return false;
  } finally {
    // noop(プログレスバー表示のため、スピナー非表示)
  }
}

/**
 * 進捗率による処理継続の判定
 * @param {object} self this インスタンス
 * @param userData APIレスポンスのuser_data
 * @returns 実行結果
 */
async function targetProgressJudge(self, userData) {
  self.progress = userData.progress;
  const readDetailRequestId = userData.request_id;
  // プログレスバー反映のため、sleepする
  await util.sleep(process.env.VUE_APP_WORK_SUPPORT_RETRY_INTERVAL);
  if (self.progress < 100) {
    // 継続中の場合、再度履歴データ読み出し（各DIDレコード処理）のGET_APIのみ呼び出し
    if (!await getReadHistoryDetailResult(self, readDetailRequestId)) {
      return false;
    }
  } else {
    // 完了の場合、取得したS3ファイルパスを配列に格納
    self.s3FilePathList.push(userData.file_path);
  }
  return true;
}